<template>
    <cc-modal :modal="modal" @close="close">
        <div slot="header-actions">
            <div class="row">
                <div class="col actions"></div>
            </div>
        </div>
        <div slot="body" class="container-fluid mb-2">
            <div class="row">
                <vue-dropzone
                    id="dropzoneFile"
                    ref="myVueDropzoneFile"
                    class="dropzone"
                    :use-custom-slot="true"
                    :options="dropzoneOptions"
                    @vdropzone-success="successResponseFile"
                    @vdropzone-sending="sendingEvent"
                >
                    <div class="dropzone-custom-content">
                        <i class="fas fa-cloud-upload-alt"></i>
                        <h5 class="dropzone-custom-title">Solte o arquivo para importar</h5>
                    </div>
                </vue-dropzone>
            </div>
        </div>
    </cc-modal>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import * as CONSTANTS from "@/constants/constants";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";

export default {
    components: { vueDropzone: vue2Dropzone },
    mixins: [loaderMixin],
    data() {
        return {
            modal: {
                title: `importar produtos`,
                subtitle: `Aqui você importa os produtos padrão`,
                icon_title: "fas fa-upload",
                cancel_text: "Voltar",
                style: {
                    width: "70%",
                    height: "fit-content",
                },
            },
            dropzoneOptions: {
                url: `${CONSTANTS.API_V3_URL}/admin/management/products/import`,
                timeout: 600000,
                paramName: "file",
                withCredentials: false,
                forceFallback: false,
                headers: this.getHeaders(),
            },
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
        getHeaders() {
            return {
                Authorization: "Bearer " + localStorage.getItem("token"),
                "Cache-Control": null,
            };
        },
        sendingEvent(file, xhr, formData) {
            // No additional form data to append
        },
        successResponseFile(file, response) {
            this.$emit("success", response);
            this.present_success(
                "Importação enviada com sucesso! Espere algums minutos enquanto processamos seu arquivo em background. Pode fechar essa janela."
            );
            this.close();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./import-products.modal";
</style>
